"use strict";
//import smoothscroll from "smoothscroll-polyfill";
import { addEvent } from "./addEvent/addEvent";
import { isMobile } from "./isMobile/isMobile";
import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";
import { mobileMenu } from "./mobileMenu/mobileMenu";
import { mainPageBaner } from "./mainPageBaner/mainPageBaner";
//import { backgroundPhotoSlider } from "./backgroundPhotoSlider/backgroundPhotoSlider";
import { ajaxFormClass } from "./form/form";
import { scrollIt } from "./scrollIt/scrollIt";
import { popUp } from "./popUp/popUp";
import { pageBaner } from "./pageBaner/pageBaner";
import { lazyLoadImage } from "./lazyLoading/lazyLoading";
import { showMoreInfo } from "./showMoreInfo/showMoreInfo";
import { addVideoToPage } from "./addVideoToPage/addVideoToPage";

import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
});

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  mobileMenuInit();
  pageScroled();
  faqList();
  formFileList();
  powieksz_zdjecie();
  forms();
  akceptacja_ciasteczka();
  showMoreInfoInit();

  if (isMobile()) {
    //$("body").addClass("mobile");
    scrollSnapClickScrollInit();
  }
}

function afterLoadStart() {
  mainPageBanerInit();
  pageBanerInit();
  //scrollToElementInit();
  //popUpInit();
  popUp();
  swiperInit();
  addVideoToPage();
  lazyLoadImage(document.querySelectorAll("[data-images]"));
}

function resize() {
  pageScroled();
}

function scroll() {
  pageScroled();
}

/*----- CODE BELOW -----*/

function swiperInit() {
  const swiperThumbails = new Swiper(".swiper-photo-list", {
    modules: [Navigation, Thumbs],
    spaceBetween: 2,
    slidesPerView: 4,
    freeMode: true,
    updateOnWindowResize: true,

    navigation: {
      nextEl: ".swiper-button-next-thumb",
      prevEl: ".swiper-button-prev-thumb",
    },
  });

  const swiper = new Swiper(".main-galery", {
    modules: [Navigation, Thumbs],

    updateOnWindowResize: true,
    slidesPerView: true,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    thumbs: {
      swiper: swiperThumbails,
    },
  });
}

function scrollSnapClickScrollInit() {
  let elements = document.querySelectorAll(".scroll-snap-section");
  elements.forEach((element) => {
    new scrollSnapClickScroll(element);
  });

  elements = document.querySelectorAll(".mobile-scroll");
  elements.forEach((element) => {
    new scrollSnapClickScroll(element);
  });
}

/*----- SCROLL TO ELEMENT -----*/
function scrollToElementInit() {
  let hash = window.location.hash;
  if (hash == "") return;

  setTimeout(() => {
    const element = document.querySelectorAll(`${hash}`);
    if (element.length != 1) return;
    const top = element[0].offsetTop;
    console.log(top);
    scrollIt(top);
  }, 500);
}

function forms() {
  let ajaxForms = $(".ajax-form");

  ajaxForms.each((idx, form) => {
    new ajaxFormClass(form);
  });
}

/*------ MORE INFO ------*/
function showMoreInfoInit() {
  const elements = document.getElementsByClassName("more-info-list");

  Array.from(elements).forEach((elm) => {
    new showMoreInfo({
      mainContainer: elm,
    });
  });
}

function mainPageBanerInit() {
  const banerTxt = document.getElementById("main-page-baner--txt");
  if (banerTxt) {
    new mainPageBaner(banerTxt);
  }
}

function pageBanerInit() {
  const elements = document.querySelectorAll(".page-baner-container");
  elements.forEach((element) => {
    new pageBaner(element);
  });
}

function mobileMenuInit() {
  window.mobileMenu = new mobileMenu();
}

function pageScroled() {
  const className = "page-scrolled";
  const showZone = document.getElementsByClassName(className);

  let scroll = $(window).scrollTop();

  if (scroll >= 10) {
    document.body.classList.add(className);
  } else {
    document.body.classList.remove(className);
  }
}

/*
function backgroundPhotoSlideInit() {
  const elements = document.querySelectorAll(".background-photo-slider");
  elements.forEach((element) => {
    new backgroundPhotoSlider(element);
  });
}
*/

function powieksz_zdjecie() {
  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

function showHideList() {
  let lists = $(".show-hide-list");

  lists.each((idx, list) => {
    $(list).find(".show-hide-list__hidden-element").hide();
    $(list)
      .children("li")
      .on("click", function () {
        if (!$(this).hasClass("show")) {
          $(this).addClass("show");
          $(this).find(".show-hide-list__hidden-element").slideDown();
        } else {
          $(this).removeClass("show");
          $(this).find(".show-hide-list__hidden-element").slideUp();
        }
      });
  });
}

function faqList() {
  let lists = $(".faq-list .faq-list__item");

  lists.each((idx, list) => {
    $(list).find(".faq-list__description").hide();
    $(list)
      .children(".faq-list__title")
      .on("click", function () {
        if (!$(this).parent().hasClass("show")) {
          $(this).parent().addClass("show");
          $(this).next(".faq-list__description").slideDown();
        } else {
          $(this).parent().removeClass("show");
          $(this).next(".faq-list__description").slideUp();
        }
      });
  });
}

function formFileList() {
  let fileInputs = $("input[type=file]");

  fileInputs.each((idx, input) => {
    input.addEventListener("change", (e) => {
      let fileNameAndSize = [];
      [...e.target.files].forEach((file) => {
        const { name: fileName, size } = file;
        const fileSize = (size / 1000).toFixed(2);
        fileNameAndSize = [
          ...fileNameAndSize,
          `<span>${fileName} [${fileSize}KB]</span>`,
        ];
      });

      $(input).parent().find(".zalaczniki-list").html(fileNameAndSize.join(""));
    });
  });
}

/*----- CIASTECZKA -----*/
function akceptacja_ciasteczka() {
  $.post("/ciasteczka", { akceptacja: -1 }, function (data) {
    if (data == 1) {
      $("div.ciasteczka-info").hide();
    }
  });

  let elm = $(".akceptuje-ciasteczka");
  if (elm.length == 0) return;

  addEvent(elm[0], "click", (e) => {
    e.preventDefault();
    console.log("akceptuje-ciasteczka");
    $.post("/ciasteczka", { akceptacja: 1 });
    $("div.ciasteczka-info").fadeOut();
    return false;
  });
}
